import { render } from "./NoDataWidget.vue?vue&type=template&id=12e4dc02&scoped=true"
import script from "./NoDataWidget.vue?vue&type=script&lang=js"
export * from "./NoDataWidget.vue?vue&type=script&lang=js"

import "./NoDataWidget.vue?vue&type=style&index=0&id=12e4dc02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e4dc02"]])

export default __exports__